export default {
  date: null,
  reference_number: null,
  type: null,
  method: null,
  amount: null,
  currency: null,
  exchange_rate: null,
  comments: null,
  files: [],
  invoices: [],
}